<template>
  <div class="test-container">
    <h2>前后端连接测试</h2>
    <button @click="testConnection">测试连接</button>
    <div v-if="result" class="result">
      <p>响应结果：{{ result }}</p>
    </div>
    <div v-if="error" class="error">
      <p>错误信息：{{ error }}</p>
    </div>
  </div>
</template>

<script>
import request from '../utils/request'

export default {
  name: 'TestView',
  data() {
    return {
      result: null,
      error: null
    }
  },
  methods: {
    testConnection() {
      this.result = null
      this.error = null
      
      // 调用后端接口
      request.get('/api/test/connection')
        .then(response => {
          console.log('后端响应：', response)
          this.result = response
        })
        .catch(err => {
          console.error('请求失败：', err)
          this.error = err.message || '连接失败，请检查后端是否启动'
        })
    }
  }
}
</script>

<style scoped>
.test-container {
  padding: 20px;
}

button {
  padding: 8px 16px;
  background-color: #42b983;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

button:hover {
  background-color: #359e75;
}

.result {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #42b983;
  border-radius: 4px;
}

.error {
  margin-top: 20px;
  padding: 10px;
  border: 1px solid #ff4d4f;
  border-radius: 4px;
  color: #ff4d4f;
}
</style>